module.exports = __webpack_public_path__ + "img/logo.185092f2.svg";